import { render } from "./OnboardingPhoto.vue?vue&type=template&id=17916951&scoped=true&ts=true"
import script from "./OnboardingPhoto.vue?vue&type=script&lang=ts"
export * from "./OnboardingPhoto.vue?vue&type=script&lang=ts"

import "./OnboardingPhoto.vue?vue&type=style&index=0&id=17916951&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17916951"]])

export default __exports__